import { convertOnlineLayout, getSiteCode } from './code/index.js';
import { applyDocumentExternalUpdates, getSiteDocument } from './document/index.js';
import { buildState } from './state/state.js';
import { applyFsUpdates } from './applyFsUpdates.js';
export class WixSiteFSManager {
    state;
    constructor(state) {
        this.state = state;
    }
    static async create(rootFolderPath, fileStructureType) {
        const state = await buildState(rootFolderPath, fileStructureType);
        return new WixSiteFSManager(state);
    }
    getCode = async () => getSiteCode(this.state);
    getDocument = async () => getSiteDocument(this.state);
    applyFsUpdates = async (updates) => applyFsUpdates(this.state, updates);
    applyExternalUpdates = async ({ code, document }) => {
        if (code) {
            throw new Error('external code updates are not supported');
        }
        if (document) {
            await applyDocumentExternalUpdates(this.state, document);
        }
    };
    createConvertOnlineLayoutApi = (basePath) => (onlinePath) => convertOnlineLayout(this.state, basePath, onlinePath);
}
